/**
 * @generated SignedSource<<c118b4a0c28bd2737fdb58805cc0e6b0>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type rowActions_AtlassianConversationAssistantPreviewCard$data = {
  readonly projectId: string | null;
  readonly " $fragmentType": "rowActions_AtlassianConversationAssistantPreviewCard";
};
export type rowActions_AtlassianConversationAssistantPreviewCard$key = {
  readonly " $data"?: rowActions_AtlassianConversationAssistantPreviewCard$data;
  readonly " $fragmentSpreads": FragmentRefs<"rowActions_AtlassianConversationAssistantPreviewCard">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "rowActions_AtlassianConversationAssistantPreviewCard",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "projectId"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "e7eb31a17a077a75b82350b332a1bf6d";

export default node;
